import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EpButtonType, EpButtonStyle } from '@epicor/kinetic';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';
import { Location } from '@angular/common';
import { QuickOrderLineModel } from '../../models/quick-order-line.model';
import { FieldAgentClient, ProductPrice } from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { ProductType, QuantityType } from 'ep-bt-controls';
import { Router } from '@angular/router';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-quick-order-line-negotiation',
  templateUrl: './epbt-fa-quick-order-line-negotiation.component.html',
  styleUrls: ['./epbt-fa-quick-order-line-negotiation.component.scss']
})
export class EpbtFaQuickOrderLineNegotiationComponent implements OnInit {
  constructor(public quickOrderService: EpbtFaQuickOrderService,
    private location: Location,
    private client: FieldAgentClient,
    private faService: EpbtFieldAgentService,
    private formBuilder: FormBuilder,
    private router: Router) { }

  selectedInputPerId: number;
  selectedUnitSellPricePerPerId: number;
  perLabel = 'UOM';
  quickOrderLine: QuickOrderLineModel;
  EpButtonType = EpButtonType;
  EpButtonStyle = EpButtonStyle;
  lineNegotiationForm: FormGroup;
  submitted = false;
  negotiateOrderLinePricesFlag = false;

  @Output() onSaveOrCancelClick = new EventEmitter<any>();

  ngOnInit() {
    if (!this.quickOrderService.quickOrderLine || !this.quickOrderService.quickOrderLine.Product) {
      this.location.back();
    }
    else {
      this.lineNegotiationForm = this.formBuilder.group({
        quantity: ['', [Validators.required, Validators.pattern('^[0-9]{1,6}(\\.[0-9]+)?$')]],
        unitSellPrice: ['', Validators.required],
        discount1: ['', Validators.max(100)],
        discount2: ['', Validators.max(100)],
        lineNotes: [''],
        specialOrderProductDescription: ['', this.quickOrderService.quickOrderLine.Product.autoCreateSpecialFromThis > 0 ? Validators.required : null]
      });
    }

    if (!this.faService.webTrackUser) {
      this.faService.getWebTrackUser((webTrackUser: any) => {
        this.faService.checkDisplayPermissions('NegotiateOrderLinePrices', (NegotiateOrderLinePricesFlag: any) => {
          this.negotiateOrderLinePricesFlag = NegotiateOrderLinePricesFlag ? false : true;
        });

        this.loadQuickOrderLineData((flag: any) => {
          this.patchValues();
        });
      });
    } else {
      this.faService.checkDisplayPermissions('NegotiateOrderLinePrices', (NegotiateOrderLinePricesFlag: any) => {
        this.negotiateOrderLinePricesFlag = NegotiateOrderLinePricesFlag ? false : true;
      });
      this.loadQuickOrderLineData((flag: any) => {
        this.patchValues();
      });
    }
  }

  /// <summary>
  /// Update UI controls from DB
  /// or QuickOrder.Line QuickOrderLine object - declared in ProductInfoPage class
  /// </summary>
  loadQuickOrderLineData(subscribe: (flag: any) => void) {
    this.client.loadProductPers(this.quickOrderService.quickOrderLine.Product).subscribe(resultProduct => {
      this.quickOrderService.quickOrderLine.Product = resultProduct;

      if (this.quickOrderService.quickOrderLine && this.quickOrderService.quickOrderLine.Per && this.quickOrderService.quickOrderLine.Per.perId > 0) {
        this.selectedUnitSellPricePerPerId = this.quickOrderService.quickOrderLine.Per.perId;
      } else {
        // Need to add this condition as well
        // changing the below condition because we are not updating the selected customer to WebtrackUser, so checking directly in QuickOrderModel.customer
        // if (this.faService.webTrackUser && this.faService.webTrackUser.customer.useEachPricing &&
        // (this.quickOrderService.quickOrderLine.Product.productType == ProductType.TimberTallied || this.quickOrderService.quickOrderLine.Product.productType == ProductType.TimberSheetMaterial)) {
        if (this.quickOrderService.quickOrder.customer && this.quickOrderService.quickOrder.customer.useEachPricing &&
          (this.quickOrderService.quickOrderLine.Product.productType == ProductType.TimberTallied || this.quickOrderService.quickOrderLine.Product.productType == ProductType.TimberSheetMaterial)) {
          const eaches = this.quickOrderService.quickOrderLine.Product.sellPricePers.filter(x => x.perCode.toLocaleUpperCase() == 'EACH');
          if (eaches && eaches.length > 0) {
            this.selectedUnitSellPricePerPerId = eaches[0].perId;
          } else {
            this.selectedUnitSellPricePerPerId = this.quickOrderService.quickOrderLine.Product.sellPer.perId;
          }
        } else {
          this.selectedUnitSellPricePerPerId = this.quickOrderService.quickOrderLine.Product.sellPer.perId;
        }
      }

      if (this.quickOrderService.quickOrderLine.InputPer && this.quickOrderService.quickOrderLine.InputPer.perId > 0) {
        this.selectedInputPerId = this.quickOrderService.quickOrderLine.InputPer.perId;
      } else {
        this.selectedInputPerId = this.quickOrderService.quickOrderLine.Product.inputPer.perId;
      }
      subscribe(true);
    });
  }

  /// <summary>
  ///  Recalculate line total
  /// </summary>
  /// <param name="useManualPrice"></param>
  /// <param name="updateSellPrice"></param>
  /// <param name="includeDiscounts"> ignore discounts</param>
  updateQuickOrderLineData(useManualPrice: boolean, updateSellPrice: boolean, includeDiscounts: boolean = false, subscribe: (flag: any) => void) {
    if (this.quickOrderService.quickOrderLine.Product.autoCreateSpecialFromThis > 0) {
      this.quickOrderService.quickOrderLine.SpecialProductDescription = this.lineNegotiationForm.controls['specialOrderProductDescription'].value;
      this.quickOrderService.quickOrderLine.Product.description = this.quickOrderService.quickOrderLine.SpecialProductDescription;
    }

    if (!includeDiscounts) {
      this.quickOrderService.quickOrderLine.Discount1 = 0.0;
      this.quickOrderService.quickOrderLine.Discount2 = 0.0;
    } else {
      this.quickOrderService.quickOrderLine.Discount1 = this.lineNegotiationForm.controls['discount1'].value ? this.lineNegotiationForm.controls['discount1'].value : 0.00;
      this.quickOrderService.quickOrderLine.Discount2 = this.lineNegotiationForm.controls['discount1'].value ? this.lineNegotiationForm.controls['discount2'].value : 0.00;
    }

    this.quickOrderService.quickOrderLine.Quantity = this.lineNegotiationForm.controls['quantity'].value;
    this.quickOrderService.quickOrderLine.UnitSellPrice = this.lineNegotiationForm.controls['unitSellPrice'].value;

    this.quickOrderService.getOrderLinePrice(useManualPrice, this.quickOrderService.quickOrderLine.Product.productId, (linePrice: ProductPrice) => {

      if (updateSellPrice) {
        this.quickOrderService.quickOrderLine.UnitSellPrice = linePrice.unitSellPrice;
      }

      this.lineNegotiationForm.controls['unitSellPrice'].setValue(this.quickOrderService.quickOrderLine.UnitSellPrice);
      this.quickOrderService.quickOrderLine.TotalSellPrice = linePrice.totalSellPrice;

      // Update line notes
      this.quickOrderService.quickOrderLine.LineNotes = this.lineNegotiationForm.controls['lineNotes'].value;

      // Update SellPer
      const eaches = this.quickOrderService.quickOrderLine.Product.sellPricePers.filter(p => p.perId == linePrice.unitSellPerID);
      this.quickOrderService.quickOrderLine.Per = eaches && eaches.length > 0 ? eaches[0] : null;

      // refresh selected index because this.quickOrderService.quickOrderLine.Per.perId could changes as result of getOrderLinePrice
      this.selectedUnitSellPricePerPerId = this.quickOrderService.quickOrderLine.Per.perId;
      subscribe(true);
    });
  }

  patchValues() {
    this.lineNegotiationForm.patchValue({
      quantity: this.quickOrderService.quickOrderLine.Quantity,
      unitSellPrice: this.quickOrderService.quickOrderLine.UnitSellPrice,
      discount1: this.quickOrderService.quickOrderLine.Discount1 ? this.quickOrderService.quickOrderLine.Discount1 : 0,
      discount2: this.quickOrderService.quickOrderLine.Discount2 ? this.quickOrderService.quickOrderLine.Discount2 : 0,
      lineNotes: this.quickOrderService.quickOrderLine.LineNotes,
      specialOrderProductDescription: this.quickOrderService.quickOrderLine.SpecialProductDescription
    });

    if (this.quickOrderService.quickOrderLine.Product.autoCreateSpecialFromThis > 0) {
      // this.SpecialOrderProductDescriptionValidator.Enabled = false;
    }

    // Item 192317 Disable price adjustments controls if user has no permissions
    // if (BTCUserSession.Current.CurrentUser.Permissions("NegotiateOrderLinePrices").PerYes != Core.Objects.Enumerations.PermissionLevel.pleGranted)
    // {
    //     this.UnitSellPrice.Enabled = false;
    //     this.Discount1.Enabled = false;
    //     this.Discount2.Enabled = false;
    // }
  }

  // This will be use in html code for validation
  get frmFields() { return this.lineNegotiationForm.controls; }

  onLineNegotiationSave() {

    this.submitted = true;
    if (this.lineNegotiationForm.invalid || !this.quickOrderService.checkMaxQuantityLimitForRelatedProducts()) {
      return;
    } else {

      if (this.lineNegotiationForm.controls['unitSellPrice'].value != this.quickOrderService.quickOrderLine.CurrentStandardUnitSellPrice) {
        this.quickOrderService.quickOrderLine.IsManuallyPriced = true;
      }

      this.updateQuickOrderLineData(this.quickOrderService.quickOrderLine.IsManuallyPriced, false, true, (flag: boolean) => {
        // Below properties are used only for binding
        if (this.quickOrderService.quickOrderLine.Product.autoCreateSpecialFromThis > 0) {
          this.quickOrderService.quickOrderLine.description = this.quickOrderService.quickOrderLine.SpecialProductDescription;
        } else {
          this.quickOrderService.quickOrderLine.description = this.quickOrderService.quickOrderLine.Product.description;
        }

        const index = this.quickOrderService.quickOrder.Lines.findIndex(x => x.LineNumber == this.quickOrderService.quickOrderLine.LineNumber);
        if (index != -1) {
          this.quickOrderService.quickOrder.Lines[index] = this.quickOrderService.quickOrderLine;
        } else {
          this.quickOrderService.quickOrder.LineAdd(this.quickOrderService.quickOrderLine);
        }

        if (this.quickOrderService.selectedRelatedproduct && this.quickOrderService.selectedRelatedproduct.length > 0) {
          const count = 0;
          this.quickOrderService.createRelatedProductOrderLine(count, (flag: boolean) => {
          });
        } else {
          this.router.navigate(['/home/quickorder']);
        }
      });
    }
  }

  onSaveOrCancelSubmit(flag: boolean) {
    // True - Save clicked False - Cancel Clicked
    if (flag) {
      this.onLineNegotiationSaveForNewOrder((flag: boolean) => {
        this.onSaveOrCancelClick.emit(flag);
      });
    } else {
      this.onSaveOrCancelClick.emit(true);
    }
  }

  onLineNegotiationSaveForNewOrder(subscribe: (flag: any) => void) {
    this.submitted = true;
    if (this.lineNegotiationForm.invalid) {
      subscribe(false);
    } else {

      if (this.lineNegotiationForm.controls['unitSellPrice'].value != this.quickOrderService.quickOrderLine.CurrentStandardUnitSellPrice) {
        this.quickOrderService.quickOrderLine.IsManuallyPriced = true;
      }

      this.updateQuickOrderLineData(this.quickOrderService.quickOrderLine.IsManuallyPriced, false, true, (flag: boolean) => {
        // Below properties are used only for binding
        if (this.quickOrderService.quickOrderLine.Product.autoCreateSpecialFromThis > 0) {
          this.quickOrderService.quickOrderLine.description = this.quickOrderService.quickOrderLine.SpecialProductDescription;
        } else {
          this.quickOrderService.quickOrderLine.description = this.quickOrderService.quickOrderLine.Product.description;
        }

        const index = this.quickOrderService.quickOrder.Lines.findIndex(x => x.LineNumber == this.quickOrderService.quickOrderLine.LineNumber);
        if (index != -1) {
          this.quickOrderService.quickOrder.Lines[index] = this.quickOrderService.quickOrderLine;
        } else {
          this.quickOrderService.quickOrder.LineAdd(this.quickOrderService.quickOrderLine);
        }
        // if (!isPopup)
        //   this.router.navigate(['/home/quickorder']);
        subscribe(true);
      });
    }
  }

  onInputPerChange(selectedValue: any): void {
    if (selectedValue) {
      this.quickOrderService.quickOrderLine.OldPerId = this.quickOrderService.quickOrderLine.Per.perId;
      const eaches = this.quickOrderService.quickOrderLine.Product.inputPers.filter(p => p.perId == selectedValue.perId);
      if (eaches && eaches.length > 0) { this.quickOrderService.quickOrderLine.InputPer = eaches[0]; }
    }
  }

  onUnitSellPriceChange(selectedValue: any): void {
    if (selectedValue) {
      this.quickOrderService.quickOrderLine.OldPerId = this.quickOrderService.quickOrderLine.Per.perId;
      const eaches = this.quickOrderService.quickOrderLine.Product.sellPricePers.filter(p => p.perId == selectedValue.perId);
      if (eaches && eaches.length > 0) { this.quickOrderService.quickOrderLine.Per = eaches[0]; }
      this.updateQuickOrderLineData(this.quickOrderService.quickOrderLine.IsManuallyPriced, true, false, (flag: boolean) => { });
    }
  }

  cancelLineNegotiationClicked() {
    // this.router.navigate(['/home/customer/details', this.customerId]);
    // this.location.back();
    this.router.navigate(['/home/quickorder']);
  }

}
